import consumer from './consumer';

let marketingTeamSubscription = null;

export function subscribeTo(marketingTeamId) {
  if (marketingTeamSubscription) {
    marketingTeamSubscription.unsubscribe();
  }

  marketingTeamSubscription = consumer.subscriptions.create(
    { channel: 'MarketingTeamChannel', marketing_team_id: marketingTeamId },
    {
      received(data) {
        if (data.type === 'activity') {
          const feed = document.getElementById('marketing-team-feed');
          if (feed) {
            feed.insertAdjacentHTML('beforeend', data.html);
            feed.scrollTop = feed.scrollHeight;
          }
        }

        if (data.type === 'team_status') {
          document.dispatchEvent(
            new CustomEvent('marketing-team:status', { detail: data })
          );
        }

        if (data.type === 'asset_ready') {
          document.dispatchEvent(
            new CustomEvent('marketing-team:asset', { detail: data })
          );
        }
      }
    }
  );

  return marketingTeamSubscription;
}

export default { subscribeTo };
